// extracted by mini-css-extract-plugin
export default {"layout__container":"Layout_layout__container__WUg8J","body__wrap":"Layout_body__wrap__PtDsb"};